import React, {useEffect, useState} from "react";
import "./style.css";
import SearchForm from "../common/searchForm/SearchForm";
import {PaymentSearchFormProps} from "./constants/SearchForm.props";
import * as PAYMENT_LIST_PROPS from "./constants/PaymentList.props";
import {InitialListProps, ListColumnType, ListProps} from "../common/list/List.props";
import {PaymentDto} from "./dto/Payment.dto";
import List from "../common/list/List";
import axios from "axios";
import {EXPORT_PAYMENTS_TO_EXCEL, GRAPHQL} from "../../constants/ApiUrl";
import {GET_PAYMENTS} from "../../constants/query/Payment.query";
import {SearchDto} from "./dto/Search.dto";
import {InitialPaginationProps, PaginationProps} from "../common/pagination/Pagination.props";
import Pagination from "../common/pagination/Pagination";
import {Option} from "../common/searchForm/Option";
import {PaymentType} from "./constants/PaymentType";
import {DateParser} from "../../util/DateParser";
import {saveAs} from "file-saver";
import Popup from "../common/popup/Popup";
import {PopupProps} from "../common/popup/Popup.props";
import {useNavigate} from "react-router-dom";
import {PAYMENT_DETAIL} from "../../constants/Routes";
import {SearchFormUtil} from "../common/searchForm/SearchFormUtil";

export default function Payment() {
    const navigate = useNavigate();

    const searchProps = PaymentSearchFormProps;
    const [checkedSeqs, setCheckedSeqs] = useState<number[]>([]);
    const [listProps, setListProps] = useState<ListProps<PaymentDto>>(InitialListProps);
    const [paginationProps, setPaginationProps] = useState<PaginationProps>(InitialPaginationProps);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);

    useEffect(() => {
        setListProps({
            headers: [
                ...PAYMENT_LIST_PROPS.HEADERS,
                {
                    type: ListColumnType.BUTTON,
                    name: "",
                    key: "",
                    button: {
                        name: "상세 보기",
                        onClick: (seq: number) => {
                            navigate(PAYMENT_DETAIL, {state: {seq: seq}});
                        }
                    }
                }
            ],
            items: [],
            emptyProps: {
                messageText: "결제 내역이 없습니다."
            },
            onCheckedChange: (seqs: number[]) => setCheckedSeqs(seqs)
        });

        setPaginationProps(prevState => ({
            ...prevState,
            onChange: (page: number) => {
                setPaginationProps(prevState => ({
                    ...prevState,
                    currentPage: page
                }));
            }
        }));

        searchProps.onSearch = () => getPayments();
        searchProps.onUpdate = (options: Option[]) => {
            SearchFormUtil.setAllCheckboxesToTrue(options);
            searchProps.options = options;
        }
    }, []);

    useEffect(() => {
        getPayments();
    }, [paginationProps.currentPage]);

    const getPayments = () => {
        const statuses: PaymentType[] = [];

        searchProps.options[0].value.forEach((option: Option, index: number) => {
            if (option) {
                statuses.push(index);
            }
        });

        const searchDto: SearchDto = {
            statuses: statuses,
            type: searchProps.options[1].value.type,
            keyword: searchProps.options[1].value.text,
            startDate: DateParser.parseDateTime(searchProps.options[2].value.startDate, true),
            endDate: DateParser.parseDateTime(searchProps.options[2].value.endDate, false),
            page: paginationProps.currentPage
        }

        axios.post(GRAPHQL, {
            query: GET_PAYMENTS(searchDto)
        }).then(response => {
            const paymentResponse = response.data.data.getPayments;

            setPaginationProps(prevState => ({
                ...prevState,
                totalPage: paymentResponse.totalPage,
                currentPage: paymentResponse.currentPage,
            }));

            setListProps(prevState => ({
                ...prevState,
                items: paymentResponse.items
            }));

            setTotalCount(paymentResponse.totalItems);
        });
    }

    const onSaveClick = (isAll: boolean = true) => {
        if (!isAll && checkedSeqs.length === 0) {
            setPopupProps({
                subject: "결제내역 엑셀 저장",
                message1: "저장할 항목을 선택해 주세요.",
                message2: null,
                buttonName: "확인",
                onConfirm: () => setPopupProps(null),
                useCloseButton: false,
                onClose: () => {}
            });

            return;
        }

        axios.post(EXPORT_PAYMENTS_TO_EXCEL, isAll ? [] : checkedSeqs, {responseType: "blob"})
            .then(response => {
                saveAs(response.data, "결제내역.xlsx");
            });
    }

    return (
        <>
            <div className="pay-management">
                <main className="wrapper">
                    <div className="pay-body">
                        <section className="list-search-section">
                            <div className="title">
                                결제 관리
                            </div>
                            <div className="list-search-wrapper">
                                <SearchForm {...searchProps}/>
                            </div>
                        </section>
                        <div className="pay-numbers">
                            <div className="pay-wrapper">
                                <div className="pay-all-number">
                                    결제 건수 {totalCount}개
                                </div>
                                <div className="pay-choice">
                                    <button className="save all" onClick={() => onSaveClick()}>
                                        전체 엑셀저장
                                    </button>
                                </div>
                                <div className="pay-choice">
                                    <button className="save" onClick={() => onSaveClick(false)}>
                                        선택항목 엑셀저장
                                    </button>
                                </div>
                            </div>
                            <div className="pay-choice-box">
                                <List {...listProps}/>
                            </div>
                        </div>
                        <Pagination {...paginationProps}/>
                    </div>
                </main>
            </div>
            {popupProps && <Popup data={popupProps}/>}
        </>
    )
}